import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { LayoutComponent } from "./layout.component";
import { SharedComponentsModule } from "../components/shared-components.module";
import { SharedModule } from "../shared.module";
import { SimpleSelectComponent } from "../components/simple-select/simple.select.component";

@NgModule({
  declarations: [
    LayoutComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    SharedComponentsModule,
    SimpleSelectComponent
  ],
  exports: [
    LayoutComponent
  ]
})
export class LayoutModule { } 